import store from "~/js/store/store";
import { gsap, Cubic } from "gsap";
import {removeTrapFocus, trapFocus} from "~/js/common/accessibility";

export default class SizeGuideModal {
  constructor() {
    this.contents = document.querySelector('._size_guide_modal');
    if(!this.contents)return;
    this.container = this.contents.querySelector('._container');

    this.open = document.querySelectorAll('.f-sizeGuideOpen');
    this.close = document.querySelectorAll('.f-sizeGuideClose');

    this.isOpen = false;
    
    this.setup()
    this.updateAccessibility();
  }

  setup () {
    store.subscribe(((mutation, state) => {

      if(store.getters['sizeGuideModal']())
      {
        if(!this.isOpen)
        {
          this.isOpen = true;

          gsap.to(this.contents, {
            display: "block",
            opacity: 1,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 30
            },
            {
              marginTop: 0,
              duration: 0.6,
              ease: Cubic.easeOut
            }
          );
          setTimeout(function()
          {
            trapFocus(this.contents);
          }.bind(this), 500);
        }
      }
      else
      {
        if(this.isOpen)
        {
          this.isOpen = false;

          gsap.to(this.contents, {
            display: "none",
            opacity: 0,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 0
            },
            {
              marginTop: 30,
              duration: 0.3,
              ease: Cubic.easeIn
            }
          );
          removeTrapFocus(this.contents);
        }
      }
    }));
    this.close.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        store.dispatch('setSizeGuideModal', {
          sta: false
        });
        this.open[0].focus()
      });
    });
    this.open.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        store.dispatch('setSizeGuideModal', {
          sta: true
        });
      });
    });

    this.contents.addEventListener('keydown', function(e) {
      if(e.key == 'Escape') {
        store.dispatch('setSizeGuideModal', {
          sta: false
        });
      }
    });
  }

  updateAccessibility() {
    if (!this.contents) return;

    const table = this.contents.querySelector('table');
    if (!table) return;

    const tableRows = table.querySelectorAll('tr');
    if (!tableRows.length) return;

    tableRows.forEach((row, rowIndex) => {
      if (rowIndex === 0) {
        row.querySelectorAll('th')?.forEach((cell) => {
          cell.setAttribute('scope', 'col');
        });
        row.querySelectorAll('td')?.forEach((cell) => {
          cell.setAttribute('scope', 'col');
        });
      } else {
        const firstCell = row.querySelector('td');
        if (firstCell) {
          firstCell.setAttribute('scope', 'row');
        }
      }
    });
  }
}